module.exports = __webpack_public_path__ + "img/ic_brand_n_s.3a5fbcf.svg";